const getBasePath = (location) => (location.pathname.indexOf('/s/') === 0 ? `/s/${location.pathname.split(/\//g)[2]}` : '');

export default getBasePath;
